// Event bus for opening the command palette, split from CommandPalette.tsx
// so light consumers (e.g. the Header button) don't pull the palette's whole
// module graph — since WHEEL-318 that graph reaches Domain360 →
// ctiGraphService → axios's ESM build, which breaks any Jest suite whose
// import chain touches the components barrel.
export const OPEN_COMMAND_PALETTE_EVENT = 'wheel:open-command-palette';

export const openCommandPalette = () => {
  window.dispatchEvent(new CustomEvent(OPEN_COMMAND_PALETTE_EVENT));
};
